<div class="control template-chooser" *ngIf="templateGroups">
  <div class="template-group-selection" *ngIf="templateGroups.length > 1">
    <ng-template ngFor let-templateGroup
        [ngForOf]="templateGroups | paginate: {
          id: templatePagination,
          itemsPerPage: itemsPerPage(),
          currentPage: currentPage()
        }"
    >
      <div class="template-group"
           [ngClass]="{'active': templateGroup.id === selectedTemplateGroupId}"
           (click)="templateGroupClicked(templateGroup.id)">
        <img class="preview-image"
             [attr.data-src]="templateGroup.previewUrl"
             src="/assets/img/loading.gif"
             id="{{templateGroup.id}}" />
        <br />
        <label for="{{templateGroup.id}}">
          {{ templateGroup.title }}
        </label>
      </div>
    </ng-template>
  </div>
  <div class="templates" *ngIf="templateGroups.length === 1">
    <div
      *ngFor="let template of (getTemplates(templateGroups[0].id) | paginate: {
        id: templatePagination,
        itemsPerPage: itemsPerPage(),
        currentPage: currentPage()
      });
      trackBy: trackById"
         class="template"
         [ngClass]="{'active': template.id === selectedTemplateId}"
         (click)="updateSelectedTemplate(templateGroups[0].id, template.id)"
    >
      <img class="preview-image"
           src="/assets/img/loading.gif"
           [attr.data-src]="template.previewUrl" />
      <label class="title">
        {{ template.title }}
      </label>
    </div>
  </div>
  <pagination-controls  [id]="templatePagination"
                        (pageChange)="pageChanged($event)"
                        maxSize="6"
                        directionLinks="true"
                        autoHide="true"
                        previousLabel=""
                        nextLabel=""
                        screenReaderPaginationLabel="Pagination"
                        screenReaderPageLabel="page"
                        screenReaderCurrentLabel="You're on page"
  ></pagination-controls>
</div>

<div #modal class="template-selection"
     *ngIf="templateGroupSelection !== undefined">
  <div class="shroud"></div>
  <div class="content">
    <mat-card class="template-groups">
      <mat-card-header>
        <mat-card-title>
          {{ 'i18n.toolbox.layout.title' | translate }}
        </mat-card-title>
        <mat-icon svgIcon="close"
                class="close-x"
                (click)="unsetTemplateGroupSelection()"></mat-icon>
      </mat-card-header>

      <mat-card-content>
        <mat-tab-group color="accent"
                       [(selectedIndex)]="templateGroupSelectionIdx"
                       >
          <ng-container *ngFor="let templateGroup of templateGroups; trackBy: trackById">
            <mat-tab [label]="templateGroup.title">
              <div class="template-list"
                   (swipeleft)="updateSelectedTemplateGroupIndex(
                          templateGroupSelectionIdx + 1)"
                   (swiperight)="updateSelectedTemplateGroupIndex(
                          templateGroupSelectionIdx - 1)"
                   *ngIf="isVisitedTemplateGroup(templateGroup.id)"
              >
                <div *ngFor="let template of getTemplates(templateGroup.id);
                            trackBy:trackById"
                     class="template"
                     [ngClass]="{'active': template.id === selectedTemplateId}"
                     (click)="updateSelectedTemplate(
                                  templateGroup.id, template.id)"
                >
                  <div class="img">
                    <img class="preview-image"
                         src="/assets/img/loading.gif"
                         [attr.data-src]="template.previewUrl"
                         [style.borderStyle]="templatesSettings.showTemplatePreviewFrames ? 'solid': 'none'" />
                  </div>
                  <div class="meta">
                    <div class="title">{{ template.title }}</div>
                    <div class="count" *ngIf="placeholdersCount(template) > 0">
                      {{ 'i18n.toolbox.layout.template.suitableFor' | translate:placeholdersCount(template) }}
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </ng-container>
        </mat-tab-group>
      </mat-card-content>

      <mat-card-actions>
        <button mat-raised-button translate
                size="small"
                (click)="unsetTemplateGroupSelection()"
        >i18n.button.cancel</button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/template-chooser/template-chooser.component.html